import React from 'react';

import MainPage from '../pages/MainPage';
import AuthPages from '../pages/Auth';
import ContentPage from '../pages/ContentPage';
import PlaylistPage from '../pages/PlaylistPage';
import DocsPage from '../pages/DocsPage';
import DevicesPage from '../pages/DevicesPage';
import CalendarPage from '../pages/CalendarPage';
import SettingsPage from '../pages/SettingsPage';
import SetupPage from '../pages/SetupPage';

export const Path = {
  MAIN: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  SETUP: '/setup',
  CONTENT: '/content',
  PLAYLISTS: '/playlist/:id',
  DEVICES: '/devices',
  CALENDAR: '/calendar/:id',
  DOCS: '/docs',
  SETTINGS: '/settings',
  LOGOUT: '/logout',
};

export const authRoutes = [
  {
    exact: true,
    path: Path.LOGIN,
    render: (props) => <AuthPages.LoginPage {...props} />,
  },
  {
    path: Path.REGISTER,
    render: (props) => <AuthPages.RegisterPage {...props} />,
  },
  {
    path: Path.FORGOT_PASSWORD,
    render: (props) => <AuthPages.ForgotPasswordPage {...props} />,
  },
  {
    path: Path.SETUP,
    render: (props) => <SetupPage {...props} />,
  },
];

const routes = [
  {
    path: Path.CONTENT,
    render: (props) => <ContentPage {...props} />,
    isPrivate: true,
  },
  {
    path: Path.PLAYLISTS,
    render: (props) => <PlaylistPage {...props} />,
    isPrivate: true,
  },
  {
    path: Path.DOCS,
    render: (props) => <DocsPage {...props} />,
    isPrivate: true,
  },
  {
    path: Path.DEVICES,
    render: (props) => <DevicesPage {...props} />,
    isPrivate: true,
  },
  {
    path: Path.CALENDAR,
    render: (props) => <CalendarPage {...props} />,
    isPrivate: true,
  },
  {
    path: Path.SETTINGS,
    render: (props) => <SettingsPage {...props} />,
    isPrivate: true,
  },
];

export default routes;
